import { render, staticRenderFns } from "./CouponGroupsCouponListTab.vue?vue&type=template&id=419f4d9e&scoped=true"
import script from "./CouponGroupsCouponListTab.vue?vue&type=script&lang=ts"
export * from "./CouponGroupsCouponListTab.vue?vue&type=script&lang=ts"
import style0 from "./CouponGroupsCouponListTab.vue?vue&type=style&index=0&id=419f4d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419f4d9e",
  null
  
)

export default component.exports